import { browserUtil, clientGuidService, tokenService } from '../../common'
import { User, authDao } from '../../dao/auth/auth-dao'

export const authService = {
  getUsers: (): Promise<User[]> => {
    return authDao.getUsers()
  },
  partialUpdateUser: (params: { user: User; data: Partial<User> }): Promise<User> => {
    const { user, data } = params
    return authDao.partialUpdateUser({ userId: user.id, data })
  },
  updateUserNameAndLegals: (params: { name: string; acceptAllLegals?: boolean }): Promise<void> => {
    return authDao.updateUserNameAndLegals(params)
  },
  requestEmailVerification: (user: User): Promise<void> => {
    const clientGuid = clientGuidService.getOrCreate()
    return authDao.requestEmailVerification({ userId: user.id, clientGuid })
  },
  _storeTokenAndRedirect: (params: { accessToken: string; refreshToken: string; redirectUrl: string }): void => {
    const { accessToken, refreshToken, redirectUrl } = params
    tokenService.store({ accessToken, refreshToken })
    browserUtil.redirect(redirectUrl)
  },
  agreeToLatestLegalAgreements: async (): Promise<void> => {
    await authDao.agreeToLatestLegalAgreements()
  },
  getMe: async (): Promise<User> => {
    return authDao.getUserMe()
  },
  signInWithApple: async (params: { identityToken: string; redirectUrl?: string }): Promise<void> => {
    const clientGuid = clientGuidService.getOrCreate()
    const { accessToken, refreshToken } = await authDao.signInWithApple({ identityToken: params.identityToken, clientGuid })
    const finalRedirectUrl = params.redirectUrl ?? window.location.origin
    authService._storeTokenAndRedirect({ accessToken, refreshToken, redirectUrl: finalRedirectUrl })
  },
  signInWithGoogle: async (params: { idToken: string; redirectUrl?: string }): Promise<void> => {
    const { idToken, redirectUrl } = params
    const clientGuid = clientGuidService.getOrCreate()
    const { accessToken, refreshToken } = await authDao.signInWithGoogle({ idToken, clientGuid })
    const finalRedirectUrl = redirectUrl ?? window.location.origin
    authService._storeTokenAndRedirect({ accessToken, refreshToken, redirectUrl: finalRedirectUrl })
  },
  requestPasswordlessLogin: async (params: { email: string; captchaToken?: string }): Promise<{ expireDate: number }> => {
    return authDao.requestPasswordlessLogin(params)
  },
  verifyPasswordlessLogin: async (params: { email: string; code: string; redirectUrl?: string }): Promise<void> => {
    const { email, code, redirectUrl: initRedirectUrl } = params
    const clientGuid = clientGuidService.getOrCreate()
    const {
      accessToken,
      refreshToken,
      redirectUrl: apiRedirectUrl,
    } = await authDao.verifyPasswordlessLogin({ email, code, clientGuid })
    const redirectUrl = initRedirectUrl ?? apiRedirectUrl
    authService._storeTokenAndRedirect({ accessToken, refreshToken, redirectUrl })
  },
  resendPasswordlessCode: async (params: { email: string }): Promise<{ expireDate: number }> => {
    return authDao.resendPasswordlessCode(params)
  },
}
